import { render, staticRenderFns } from "./LeadsPage.vue?vue&type=template&id=6c733ad2&scoped=true&"
import script from "./LeadsPage.vue?vue&type=script&lang=js&"
export * from "./LeadsPage.vue?vue&type=script&lang=js&"
import style0 from "./LeadsPage.vue?vue&type=style&index=0&id=6c733ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c733ad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c733ad2')) {
      api.createRecord('6c733ad2', component.options)
    } else {
      api.reload('6c733ad2', component.options)
    }
    module.hot.accept("./LeadsPage.vue?vue&type=template&id=6c733ad2&scoped=true&", function () {
      api.rerender('6c733ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LeadsPage.vue"
export default component.exports